import type { QueryClient } from '@tanstack/react-query';

/**
 * Every list that shows calls or call remarks — refetched after a call is placed or a remark is
 * saved, so nobody has to reload the page to see it (operator, 24-10).
 *
 *  - `ivr-logs` / `ivr-log`        IVR page list and the call-history pop-up
 *  - `ivr-calls`                   Settings → IVR call history
 *  - `ivr-summary` / `ivr-user-summary`  IVR summary tiles
 *  - `order-calls`                 "Calls & Recording" on the order screens
 *  - `ndr`                         the NDR queue's IVR / Call column
 */
export function refreshCallLists(qc: QueryClient) {
  for (const key of ['ivr-logs', 'ivr-log', 'ivr-calls', 'ivr-summary', 'ivr-user-summary', 'order-calls', 'ndr']) {
    qc.invalidateQueries({ queryKey: [key] });
  }
}
